import ReactApexChart from 'react-apexcharts';
// legendPosition as props
const Pie = ({ labels, series,  height = 350 }) => {
  var themeColorRgb = getComputedStyle(document.body).getPropertyValue('--bs-theme-rgb').trim();
  var themeFont = getComputedStyle(document.body).getPropertyValue('--bs-body-font-family').trim();
  var indigoRgb = getComputedStyle(document.body).getPropertyValue('--bs-indigo-rgb').trim();
  var pinkRgb = getComputedStyle(document.body).getPropertyValue('--bs-pink-rgb').trim();
  var orangeRgb = getComputedStyle(document.body).getPropertyValue('--bs-warning-rgb').trim();
  var inverse = getComputedStyle(document.body).getPropertyValue('--bs-inverse').trim();
  var inverseRgb = getComputedStyle(document.body).getPropertyValue('--bs-inverse-rgb').trim();

  const pieOptions = {
    // ...options,
    labels:labels,
    dataLabels: { dropShadow: { enabled: false, top: 1, left: 1, blur: 1, opacity: 1 } },
    stroke: { show: false },
    colors: [
      'rgba(' + themeColorRgb + ', .75)',
      'rgba(' + pinkRgb + ', .75)',
      'rgba(' + orangeRgb + ', .75)',
      'rgba(' + inverseRgb + ', .5)',
      'rgba(' + themeColorRgb + ', .50)',
      'rgba(' + themeColorRgb + ', .5)',
      'rgba(' + themeColorRgb + ', 1)',
      'rgba(' + indigoRgb + ', .75)',
    ],
    legend: { fontFamily: themeFont, labels: { colors: inverse } ,  position: 'bottom' },
    // title: {
    //   style: {
    //     text: title  ,
    //     fontSize: '14px',
    //     fontWeight: 'bold',
    //     fontFamily: themeFont,
    //     color: inverse,
    //   },
    // },
  };

  return <ReactApexChart options={pieOptions} series={series} type="pie" height={height} />;
};

export default Pie;
